<img [src]="staticMapSrc" class="map-image" />
